export const importInfo = window.location.origin.includes("localhost:2000") ?
    {key: "aa9434150bbdb284daf34a9ac44adb18", email: "loveimportertest@test.com"} :
    {key: "ce1f9a495311149f7e70a0b6f32634fd", email: "info@lovespreadsheets.com"}